module.exports = __webpack_public_path__ + "static/media/youtubeParaIniciantesComoCriarCrescerSeuCanal.23481713.png";